var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("tr", [
    _c("td", [_vm._v(_vm._s(_vm.index + 1))]),
    _vm._v(" "),
    _c("td", [
      _c("p", [
        _vm._v("Заявка: "),
        _c("strong", [_vm._v(_vm._s((_vm.order.id + "").substr(-4)))]),
        _vm._v(
          "\n      (" +
            _vm._s(
              _vm.$AllProjects[_vm.order.site_id] &&
                _vm.$AllProjects[_vm.order.site_id].name
            ) +
            ") " +
            _vm._s(_vm.moment(_vm.order.report_date, "HH:mm")) +
            "\n    "
        ),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v(_vm._s(_vm.order.address))]),
      _vm._v(" "),
      _c("table", { staticClass: "table table-sm drugs_table mt-1" }, [
        _c(
          "tbody",
          _vm._l(_vm.order.details, function (detail) {
            return _c("tr", [
              _c("td", [
                detail.new_drug.cool
                  ? _c("i", { staticClass: "icon icon-snowflake" })
                  : _vm._e(),
                _vm._v(" " + _vm._s(detail.new_drug.title)),
              ]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(detail.qty))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(detail.price))]),
            ])
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _vm.order.status == -3
        ? _c("p", { staticClass: "reject_comment" }, [
            _vm._v(_vm._s(_vm.order.reject_comment)),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("td", [
      _c("p", [_c("strong", [_vm._v(_vm._s(_vm.order.price))])]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          _vm._s(_vm.salaryRates[_vm.order.extra_options.salary_rate || 0])
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }